import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch, ref } from 'vue'
    import { guid } from '@common/Guid'
    import { copyToClipboard } from '@common/Common'
    import { useRouter, useRoute } from '@common/composables'
    import { useMyAccessTokensPage } from '@Organizations/AccessTokens/pages-core'
    import { useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import "@common/AdminNavigationV2.vue"

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ManageUserAccessTokensPage',
  setup(__props) {

    document.title = "Manage Access Tokens"

    const router = useRouter()
    const route = useRoute()

    const id = ref()
    const secret = ref()
    const copied = ref(false)

    // Get user ID from route parameter
    const targetUserId = computed(() => route.params.id as string)

    const {
        useCurrentUserQuery,
        useUserAccessTokensQuery,
        useGenerateAccessTokenCommand,
        useRevokeAccessTokenCommand,
    } = useMyAccessTokensPage()

    const accessToken = computed(() => btoa(`${id.value}/${secret.value}`))

    // Get current admin user info
    const { modelCurrentUserQueryV1: currentUserModel, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const organizationUnitId = computed(() => currentUserModel.value?.OrganizationUnitId)

    // Get target user info (the service account we're managing)
    const { modelUserQueryV1, runUserQueryV1 } = useUserQueryV1(targetUserId)
    const targetUser = computed(() => modelUserQueryV1.value)

    // Get access tokens for the target user
    const { modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeed: succeedUserAccessTokensQueryV1 } = useUserAccessTokensQuery(targetUserId)
    const accessTokens = computed(() => modelUserAccessTokensQueryV1.value?.AccessTokens || [])

    const { invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1 } = useGenerateAccessTokenCommand(id, organizationUnitId, targetUserId, secret)

    const { invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1 } = useRevokeAccessTokenCommand(null, targetUserId)

    onMounted(() => {
        runCurrentUserQueryV1()
        if (targetUserId.value) {
            runUserQueryV1()
            runUserAccessTokensQueryV1()
        }
    })

    watch(targetUserId, () => {
        if (targetUserId.value) {
            runUserQueryV1()
            runUserAccessTokensQueryV1()
        }
    })

    watch(succeedGenerateAccessTokenCommandV1, () => runUserAccessTokensQueryV1())
    watch(succeedRevokeAccessTokenCommandV1, () => runUserAccessTokensQueryV1())

    function handleGenerateAccessTokenCommandV1() {
        id.value = guid()
        secret.value = `${guid()}${guid()}`.replace(/-/g, '')
        invokeGenerateAccessTokenCommandV1()
    }

    function handleRevokeAccessTokenCommandV1(token) {
        if (confirm(`Do you really want to revoke access token "${token.Name}"? This action cannot be undone.`)){
            invokeRevokeAccessTokenCommandV1({id: token.Id})
        }
    }

    function handleCopyToClipboard() {
        copyToClipboard(accessToken.value)
        copied.value = true

        const h = setTimeout(() => {
            copied.value = false
            clearTimeout(h)
        }, 2000)
    }

return { __sfc: true,router, route, id, secret, copied, targetUserId, useCurrentUserQuery, useUserAccessTokensQuery, useGenerateAccessTokenCommand, useRevokeAccessTokenCommand, accessToken, currentUserModel, runCurrentUserQueryV1, organizationUnitId, modelUserQueryV1, runUserQueryV1, targetUser, modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeedUserAccessTokensQueryV1, accessTokens, invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1, invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1, handleGenerateAccessTokenCommandV1, handleRevokeAccessTokenCommandV1, handleCopyToClipboard }
}

})